package com.example.mystybag.common.ui.components.custom

import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.core.views.isDarkTheme

@Composable
fun ShimmerBrush(showShimmer: Boolean = true, targetValue: Float = 800f): Brush {
    val theme = AppTheme.current
    return if (showShimmer) {
        val shimmerColors = remember(isDarkTheme.value) { listOf(
            theme.colors.onSurfaceVariant.copy(alpha = 0.2f),
            theme.colors.onSurfaceVariant.copy(alpha = 0.4f),
            theme.colors.onSurfaceVariant.copy(alpha = 0.2f),
        ) }
        val transition = rememberInfiniteTransition()
        val translateAnimation = transition.animateFloat(
            initialValue  = 0f,
            targetValue   = targetValue,
            animationSpec = infiniteRepeatable(
                animation   = tween(1200),
                repeatMode  = RepeatMode.Reverse
            )
        )
        Brush.linearGradient(
            colors  = shimmerColors,
            start   = Offset.Zero,
            end     = Offset(x = translateAnimation.value, y = translateAnimation.value)
        )
    } else {
        val transparentColors = remember {
            listOf(Color.Transparent, Color.Transparent)
        }
        Brush. linearGradient(
            colors  = transparentColors,
            start   = Offset.Zero,
            end     = Offset.Zero
        )
    }
}